module.exports.isPreview = viewMode =>
  viewMode === 'Preview' || viewMode === 'Editor'
